

// config.js
const config = {
    apiBaseUrl: "https://silobackendlaunch-874eb8f33c9b.herokuapp.com/"
};

export default config;

